<template>
  <div class="overview">
    <div class="update-info">
      <dl>
        <dt>基準時刻</dt>
        <dd v-if="timeInfo">
          <span>{{ formatDate(timeInfo.ref_time) }}</span>
          <span>{{ formatTime(timeInfo.ref_time) }}</span>
        </dd>

        <dt class="update">更新時刻</dt>
        <dd v-if="timeInfo">
          <span>{{ formatDate(timeInfo.upd_time) }}</span>
          <span>{{ formatTime(timeInfo.upd_time) }}</span>
        </dd>
      </dl>
    </div>
    <div class="overview-main-container">
      <template v-if="isNoAreaWeather">
        <div class="oerview-contant">
          <h2 class="overview-headline">
            <span>エリアの天気</span>
          </h2>
          <div class="wind-overhead no-wind">
            <div class="overview-teble-head">
              気象情報が作成されていません。時間をおいてアクセスしてください。
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="oerview-contant">
          <h2 class="overview-headline"><span>エリアの天気</span></h2>
          <div class="card-wheather">
            <ul>
              <li class="card" v-for="card in dayCards" :key="card.label">
                <h3>
                  <span class="unit">{{ card.label }}</span>
                  <span>{{ formatDateWithWeekday(card.summary.date) }}</span>
                </h3>

                <div class="weather-data">
                  <div class="weather-img">
                    <img :src="weatherIcon(card.summary.weather, card.summary.isNight, 'daily')" />
                    <h4>{{ WeatherIcon.getDailyText(card.summary.weather) }}</h4>
                  </div>

                  <div class="wind-info-all">
                    <p>最大風速</p>
                    <ul>
                      <li>
                        <dl>
                          <dt>地上</dt>
                          <dd>
                            {{ round1Decimal(card.summary.maxWind10m) }}
                            <span>m/s</span>
                            <img
                              :src="
                                WindIcon.getIconUrl(
                                  card.summary.maxWind10mDir,
                                  card.summary.maxWind10m,
                                )
                              "
                            />
                          </dd>
                        </dl>
                        <dl>
                          <dt>100m</dt>
                          <dd>
                            {{ round1Decimal(card.summary.maxWind100m) }}
                            <span>m/s</span>
                            <img
                              :src="
                                WindIcon.getIconUrl(
                                  card.summary.maxWind100mDir,
                                  card.summary.maxWind100m,
                                )
                              "
                            />
                          </dd>
                        </dl>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="weather-status"
                  :class="{
                    'red-status': card.summary.hasDanger,
                    'yellow-status': !card.summary.hasDanger && card.summary.hasWarning,
                  }"
                >
                  <template v-if="card.summary.hasDanger">
                    <span class="stats-icon danger"></span>
                    基準値超過
                    <span class="status-note">（飛行リスクあり）</span>
                  </template>

                  <template v-else-if="card.summary.hasWarning">
                    <span class="stats-icon warning"></span>
                    基準値超過
                    <span class="status-note">（飛行リスクあり）</span>
                  </template>

                  <template v-else> 終日、基準値未満 </template>
                </div>
              </li>
            </ul>
          </div>
          <div class="tabs-container" id="tab-interface">
            <div class="tab-buttons">
              <button
                class="tab-btn"
                :class="{ active: activeTab === 'today' }"
                @click="onTabClick('today')"
                data-tab-target="tab-content-1"
              >
                今日
              </button>

              <button
                class="tab-btn"
                :class="{ active: activeTab === 'tomorrow' }"
                @click="onTabClick('tomorrow')"
                data-tab-target="tab-content-2"
              >
                明日
              </button>

              <button
                class="tab-btn"
                :class="{ active: activeTab === 'future' }"
                @click="activeTab = 'future'"
                data-tab-target="tab-content-3"
              >
                明後日以降
              </button>
            </div>

            <div class="tab-contents">
              <div v-if="activeTab === 'today' && today">
                <div class="overview-teble-head">
                  <div>{{ formatDateWithWeekday(today.date) }}</div>
                  <div class="sunrise"><span></span>{{ today.sunrise_time }}</div>
                  <div class="sunset"><span></span>{{ today.sunset_time }}</div>
                </div>
              </div>

              <!-- 明日 -->
              <div v-if="activeTab === 'tomorrow' && tomorrow">
                <div class="overview-teble-head">
                  <div>{{ formatDateWithWeekday(tomorrow.date) }}</div>
                  <div class="sunrise"><span></span>{{ tomorrow.sunrise_time }}</div>
                  <div class="sunset"><span></span>{{ tomorrow.sunset_time }}</div>
                </div>
              </div>
              <div class="tab-pane" :class="{ active: activeTab === 'future' }" id="tab-content-3">
                <div class="overview-teble-head week-all">
                  <ul class="header-row">
                    <li>天気</li>
                    <li>
                      <span>風速<span class="unit">(m/s)</span></span>
                      <span class="side-note">-地上100m</span>
                    </li>
                    <li>
                      <span>風速<span class="unit">(m/s)</span></span>
                      <span class="side-note">-地上</span>
                    </li>
                    <li>降水量<span class="unit">(mm/h)</span></li>
                  </ul>
                </div>
                <!-- accordion-container -->
                <div class="accordion-container" id="weather-accordion-scroll-target">
                  <details
                    v-for="(day, index) in futureDays"
                    :key="day.date"
                    class="accordion-item"
                    :class="{ 'bk js-scroll-out': index < 2 }"
                  >
                    <summary class="accordion-header">
                      <div class="date-week">
                        <span class="date">{{ formatDateWithWeekday(day.date).split('(')[0] }}</span
                        >(
                        <span class="week" :class="getWeekClass(day.date)">
                          {{ getWeekChar(day.date) }}
                        </span>
                        )
                      </div>
                      <ul class="weather-summary-list">
                        <li class="summary-item weather-text">
                          <img
                            :src="weatherIcon(day.weather_day, day.is_night_flg, 'daily')"
                            :alt="WeatherIcon.getDailyText(day.weather_day)"
                          />
                        </li>
                        <li class="summary-item wind-top" :class="alertClass(day.wind_alert_100m)">
                          <img
                            :src="
                              WindIcon.getIconUrl(
                                day.wind_dir_max_day_100m,
                                day.wind_speed_max_day_100m,
                              )
                            "
                          />
                          <span class="value">
                            {{ round1Decimal(day.wind_speed_max_day_100m) }}
                          </span>
                        </li>
                        <li
                          class="summary-item wind-bottom"
                          :class="alertClass(day.wind_alert_10m)"
                        >
                          <img
                            :src="
                              WindIcon.getIconUrl(
                                day.wind_dir_max_day_10m,
                                day.wind_speed_max_day_10m,
                              )
                            "
                          />
                          <span class="value">
                            {{ round1Decimal(day.wind_speed_max_day_10m) }}
                          </span>
                        </li>
                        <li class="summary-item rain-chance" :class="alertClass(day.precip_alert)">
                          <span class="value">{{ round1Decimal(day.precip_sum_day) }}</span>
                        </li>
                      </ul>
                    </summary>
                    <div class="accordion-content">
                      <ul class="hourly-weather-list">
                        <li class="hourly-item" v-for="hour in day.hours" :key="hour.hour">
                          <div class="hour">{{ hour.hour }}:00</div>
                          <ul class="hour-data">
                            <li class="weather-icon">
                              <img
                                :src="weatherIcon(hour.weather, hour.is_night_flg, 'hourly')"
                                :alt="WeatherIcon.getDailyText(hour.weather)"
                              />
                            </li>
                            <li class="wind-info-top" :class="alertClass(hour.wind_alert_100m)">
                              <img
                                :src="WindIcon.getIconUrl(hour.wind_dir_100m, hour.wind_speed_100m)"
                              />
                              <span class="value">{{ round1Decimal(hour.wind_speed_100m) }}</span>
                            </li>
                            <li class="wind-info-bottom" :class="alertClass(hour.wind_alert_10m)">
                              <img
                                :src="WindIcon.getIconUrl(hour.wind_dir_10m, hour.wind_speed_10m)"
                              />
                              <span class="value">{{ round1Decimal(hour.wind_speed_10m) }}</span>
                            </li>
                            <li class="rain-info" :class="alertClass(hour.precip_alert)">
                              <span class="value">{{ round1Decimal(hour.precip_1hour) }}</span>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </details>
                </div>
                <ul class="usage-note-overview weather-2week">
                  <li><span></span>注意以上</li>
                  <li><span></span>警戒以上</li>
                </ul>
              </div>
            </div>
            <div v-show="activeTab !== 'future'">
              <div class="table-weather-day day-2">
                <ul class="header-column">
                  <li>時刻</li>
                  <li>飛行リスク</li>
                  <li>天気</li>
                  <li>
                    <span>風速<span class="unit">(m/s)</span></span
                    ><span class="side-note">-地上100m</span>
                  </li>
                  <li>
                    <span>風速<span class="unit">(m/s)</span></span
                    ><span class="side-note">-地上</span>
                  </li>
                  <li>
                    <span>降水量<span class="unit">(mm/h)</span></span>
                  </li>
                  <li>
                    <span>気温<span class="unit">(℃)</span></span>
                  </li>
                </ul>
                <div
                  class="weather-hour"
                  id="weather-hour-container"
                  ref="weatherHourContainer"
                  @scroll="handleHourScroll"
                >
                  <ul class="data-column" v-for="(item, i) in continuousHours" :key="i">
                    <li class="hour">{{ item.hour }}</li>
                    <li class="risk-warning">
                      <template v-if="getHourRiskLevel(item.raw) === 2">
                        <img
                          src="../assets/images/icon/icon_danger.svg"
                          alt="Danger"
                          class="risk-icon"
                        />
                      </template>

                      <template v-else-if="getHourRiskLevel(item.raw) === 1">
                        <img
                          src="../assets/images/icon/icon_warning.svg"
                          alt="Warning"
                          class="risk-icon"
                        />
                      </template>

                      <template v-else> - </template>
                    </li>
                    <li class="weather-img">
                      <img
                        :src="weatherIcon(item.raw.weather, item.raw.is_night_flg, 'hourly')"
                        :alt="WeatherIcon.getDailyText(item.raw.weather)"
                      />
                    </li>
                    <li :class="alertClass(item.raw.wind_alert_100m)">
                      <img
                        :src="WindIcon.getIconUrl(item.raw.wind_dir_100m, item.raw.wind_speed_100m)"
                      />
                      <span class="value">{{ round1Decimal(item.raw.wind_speed_100m) }}</span>
                    </li>
                    <li :class="alertClass(item.raw.wind_alert_10m)">
                      <img
                        :src="WindIcon.getIconUrl(item.raw.wind_dir_10m, item.raw.wind_speed_10m)"
                      />
                      <span class="value">{{ round1Decimal(item.raw.wind_speed_10m) }}</span>
                    </li>
                    <li :class="alertClass(item.raw.precip_alert)">
                      <span class="value">{{ round1Decimal(item.raw.precip_1hour) }}</span>
                    </li>
                    <li :class="alertClass(item.raw.temp_alert)">
                      <span class="value">{{ round1Decimal(item.raw.temp) }}</span>
                    </li>
                  </ul>
                </div>
              </div>
              <ul class="usage-note-overview">
                <li><span></span>注意以上</li>
                <li><span></span>警戒以上</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="oerview-contant route-wind">
          <h2 class="overview-headline"><span>航路情報</span></h2>
          <template v-if="!hasRoutes">
            <div class="route-wind-container">
              <div class="route-wind-search no-route">
                <ul class="route-wind-search-form">
                  <li>
                    <label class="label-l">航路名</label>
                    <select disabled></select>
                  </li>

                  <li class="opt-time">
                    <fieldset class="fieldset-group">
                      <legend class="fieldset-legend">出発日時</legend>
                      <input type="date" name="departure_date" class="datepicker" value="null" />
                      <ul>
                        <li>
                          <select disabled></select>
                          <span>時</span>
                        </li>
                        <li>
                          <select disabled></select>
                          <span>分</span>
                        </li>
                      </ul>
                    </fieldset>
                  </li>
                </ul>

                <div class="setup-prompt">
                  <p>
                    航路が未登録です。<br />
                    パソコンから航路情報設定でCSVファイルを取り込んで登録してください。
                  </p>
                  <button class="button-primary" @click="$router.push('/flight-routes')">
                    航路情報設定へ
                  </button>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="route-wind-container">
              <div class="route-wind-search">
                <ul class="route-wind-search-form">
                  <li>
                    <label for="" class="label-l"> 航路名 </label>
                    <select
                      name="area"
                      v-model="selectedFlightRouteId"
                      :disabled="isLoadingRoutes || flightRoutes.length === 0"
                    >
                      <option
                        v-for="route in flightRoutes"
                        :key="route.flight_route_id"
                        :value="route.flight_route_id"
                      >
                        {{ route.flight_route_name }}
                      </option>
                    </select>
                  </li>
                  <li class="opt-time">
                    <fieldset class="fieldset-group">
                      <legend class="fieldset-legend">出発日時</legend>
                      <input
                        type="date"
                        name="departure_date"
                        class="datepicker"
                        v-model="inputDate"
                        :min="minDate"
                        :max="maxDate"
                      />
                      <ul>
                        <li>
                          <select name="hour" v-model="inputHour">
                            <option v-for="h in 24" :key="h" :value="h - 1">
                              {{ h - 1 }}
                            </option>
                          </select>
                          <span>時</span>
                        </li>
                        <li>
                          <select name="minute" v-model="inputMinute">
                            <option v-for="m in 60" :key="m" :value="m - 1">
                              {{ m - 1 }}
                            </option>
                          </select>
                          <span>分</span>
                        </li>
                      </ul>
                    </fieldset>
                  </li>
                </ul>
                <ul class="route-wind-search-display">
                  <li>
                    <span>{{ selectedRoute?.points?.[0]?.point_name }}</span
                    ><span>({{ routeStartTimeText }})</span>
                  </li>
                  <li>
                    <span>{{
                      selectedRoute?.points?.[selectedRoute?.points?.length - 1]?.point_name
                    }}</span
                    ><span>({{ routeEndTimeText }})</span>
                  </li>
                </ul>
                <div class="submit">
                  <button class="button-secondary" @click="onSearch" :disabled="isSearching">
                    <span>
                      <img src="../assets/images/icon/icon_search.svg" alt="" />
                    </span>
                    検索する
                  </button>
                </div>
              </div>
              <div class="wind-on-route" :class="{ 'no-wind': !hasRouteWind }">
                <div v-if="routeRiskLevel === 2" class="wind-on-route-head head-danger">
                  <span class="icon"></span>
                  基準値超過
                  <span class="note">（飛行リスクあり）</span>
                </div>

                <div v-else-if="routeRiskLevel === 1" class="wind-on-route-head head-warning">
                  <span class="icon"></span>
                  基準値超過
                  <span class="note">（飛行リスクあり）</span>
                </div>
                <template v-if="hasRouteWind">
                  <ul class="wind-list">
                    <li v-for="(item, i) in flatRouteWeathers" :key="i" class="route-item">
                      <div>
                        <ul class="item-line-one">
                          <li class="item-time">{{ item!.time }}</li>
                          <li class="item-height">
                            <span class="height-label">高度</span>
                            <span class="height-value">{{ item!.height }}</span>
                          </li>
                          <li class="flag-icon">
                            <img
                              v-if="item!.pointProfileFlg === 1"
                              src="../assets/images/icon/icon_flag.svg"
                              alt=""
                            />
                          </li>
                        </ul>
                        <div class="item-line-two">
                          <span v-if="item!.pointPortCd === 1" class="port-label departure">
                            発
                          </span>

                          <span v-else-if="item!.pointPortCd === 2" class="port-label arrival">
                            着
                          </span>

                          <span class="item-name">{{ item!.pointName }}</span>
                          <img
                            v-if="item!.alert === 1"
                            src="../assets/images/icon/icon_warning.svg"
                            alt="warning"
                            class="risk-icon"
                          />
                          <img
                            v-if="item!.alert === 2"
                            src="../assets/images/icon/icon_danger.svg"
                            alt="danger"
                            class="risk-icon"
                          />
                        </div>
                      </div>
                      <div class="item-line-three">
                        <img :src="WindIcon.getIconUrl(item!.windDir, item!.windSpeed)" alt="" />
                        <span class="item-wind">{{ round1Decimal(item!.windSpeed) }}</span>
                      </div>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <div class="wind-on-route-head">航路上の風が設定されていません</div>
                  <p>-</p>
                </template>
              </div>
            </div>
            <template v-if="hasUpperWind">
              <WindOverhead
                :upper-weathers="filteredUpperWeathers"
                :highlight-time="highlightTime"
              />
            </template>
            <template v-else>
              <div class="wind-overhead no-wind">
                <h3>上空の風</h3>
                <div class="overview-teble-head">上空の風が設定されていません</div>
              </div>
            </template>
          </template>
        </div>
      </template>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, onMounted, computed, watch, nextTick, onUnmounted } from 'vue'
import {
  fetchTimeInfo,
  fetchAreaWeather,
  fetchRouteWeather,
  fetchUpperWind,
} from '@/api/weatherOverviewApi'
import { fetchFlightAreas } from '@/api/flightAreasApi'
import type {
  TimeInfo,
  WeatherDay,
  RouteWeatherPoint,
  UpperWeatherPoint,
  WeatherHour,
  RouteWind,
  FlatRouteWeather,
} from '@/types/weatherOverview'
import { fetchFlightRoutes } from '@/api/flightRoutesApi'
import type { FlightRoute } from '@/api/flightRoutesApi'
import { useFlightAreaStore } from '@/stores/flightArea'
import WindOverhead from '@/views/WindOverhead.vue'
import { round1Decimal } from '@/utils/common'
import WindIcon from '@/composables/WindIcon'
import WeatherIcon from '@/composables/WeatherIcon'

// 画面更新時間の設定
const REFRESH_INTERVAL_MS = 60 * 1000 // 1分

const flightAreaStore = useFlightAreaStore()
const isNoAreaWeather = computed(() => weathers.value.length === 0)

const timeInfo = ref<TimeInfo | null>(null)
const formatDate = (iso: string) => {
  const d = new Date(iso)
  return `${d.getMonth() + 1}/${d.getDate()}`
}
const formatTime = (iso: string) => {
  const d = new Date(iso)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

const baseNow = computed(() => {
  if (!timeInfo.value?.ref_time) return new Date()
  return new Date(timeInfo.value.ref_time)
})

const weathers = ref<WeatherDay[]>([])

// 今日
const today = computed(() => weathers.value[0])
// 明日
const tomorrow = computed(() => weathers.value[1])

const continuousHours = computed(() => {
  if (!weathers.value.length) return []

  const result: {
    hour: string
    dayIndex: number
    raw: WeatherHour
  }[] = []

  const currentHour = baseNow.value.getHours()

  weathers.value.slice(0, 2).forEach((day, dayIndex) => {
    day.hours.forEach((h) => {
      const hourNum = Number(h.hour)

      // 今日 → 現在時刻以降のみ
      if (dayIndex === 0 && hourNum < currentHour) return

      result.push({
        hour: h.hour,
        dayIndex,
        raw: h,
      })
    })
  })

  return result
})

// 明後日以降
const futureDays = computed(() => {
  // weathers[0]=今日, [1]=明日, [2]=明後日
  return weathers.value
})

// 1日分のカード情報を作成
const buildDaySummary = (day?: WeatherDay) => {
  if (!day) return null

  const hasDanger = day.wind_alert_10m === 2 || day.wind_alert_100m === 2 || day.precip_alert === 2
  const hasWarning = day.wind_alert_10m === 1 || day.wind_alert_100m === 1 || day.precip_alert === 1

  return {
    date: day.date,
    weather: day.weather_day,
    isNight: day.is_night_flg,

    maxWind10m: day.wind_speed_max_day_10m,
    maxWind10mDir: day.wind_dir_max_day_10m,
    maxWind10mAlert: day.wind_alert_10m,

    maxWind100m: day.wind_speed_max_day_100m,
    maxWind100mDir: day.wind_dir_max_day_100m,
    maxWind100mAlert: day.wind_alert_100m,

    hasDanger,
    hasWarning,
  }
}

const todaySummary = computed(() => buildDaySummary(today.value))
const tomorrowSummary = computed(() => buildDaySummary(tomorrow.value))
const dayCards = computed(() => {
  return [
    { label: '今日', summary: todaySummary.value },
    { label: '明日', summary: tomorrowSummary.value },
  ].filter(
    (c): c is { label: string; summary: NonNullable<typeof c.summary> } => c.summary !== null,
  )
})

// 補助関数
// アイコン
const alertClass = (alert: number) => (alert === 2 ? 'danger' : alert === 1 ? 'warning' : '')
const weatherIcon = (code: number, isNight: number, type: 'daily' | 'hourly') => {
  return type === 'daily'
    ? WeatherIcon.getDailyIconUrl(code, isNight)
    : WeatherIcon.getHourlyIconUrl(code, isNight)
}
// 日付フォーマット
const formatDateWithWeekday = (dateStr: string) => {
  let date: Date

  // ハイフン付き（2026-02-17）
  if (dateStr.includes('-')) {
    date = new Date(dateStr)
  }
  // ハイフンなし（20260217）
  else {
    const year = Number(dateStr.slice(0, 4))
    const month = Number(dateStr.slice(4, 6)) - 1
    const day = Number(dateStr.slice(6, 8))
    date = new Date(year, month, day)
  }

  const month = date.getMonth() + 1
  const day = date.getDate()

  const weekdays = ['日', '月', '火', '水', '木', '金', '土']
  const weekday = weekdays[date.getDay()]

  return `${month}/${day}(${weekday})`
}

const parseDate = (dateStr: string) => {
  if (dateStr.includes('-')) {
    return new Date(dateStr)
  } else {
    const year = Number(dateStr.slice(0, 4))
    const month = Number(dateStr.slice(4, 6)) - 1
    const day = Number(dateStr.slice(6, 8))
    return new Date(year, month, day)
  }
}

const getWeekChar = (dateStr: string) => {
  const date = parseDate(dateStr)
  const weekdays = ['日', '月', '火', '水', '木', '金', '土']
  return weekdays[date.getDay()]
}

const getWeekClass = (dateStr: string) => {
  const date = parseDate(dateStr)
  const day = date.getDay()

  if (day === 0) return 'color-red'
  if (day === 6) return 'color-blue'
  return ''
}

const getHourRiskLevel = (hour: WeatherHour) => {
  const alerts = [hour.wind_alert_10m, hour.wind_alert_100m, hour.precip_alert, hour.temp_alert]

  if (alerts.includes(2)) return 2 // 警戒優先
  if (alerts.includes(1)) return 1 // 注意
  return 0
}

// タブ切り替え
const activeTab = ref<'today' | 'tomorrow' | 'future'>('today')
const weatherHourContainer = ref<HTMLElement | null>(null)
const handleHourScroll = () => {
  if (isAutoScrolling.value) return

  const container = weatherHourContainer.value
  if (!container) return

  // 1列の幅を取得
  const firstColumn = container.querySelector<HTMLElement>('.data-column')
  if (!firstColumn) return

  const columnWidth = firstColumn.offsetWidth

  // 何列目が左端か計算
  const index = Math.floor(container.scrollLeft / columnWidth)
  const item = continuousHours.value[index]
  if (!item) return

  if (item.dayIndex === 0) {
    activeTab.value = 'today'
  } else if (item.dayIndex === 1) {
    activeTab.value = 'tomorrow'
  }
}
const isAutoScrolling = ref(false)
watch(activeTab, async (tab) => {
  if (tab !== 'future') return
  await nextTick()

  const container = document.getElementById('weather-accordion-scroll-target')
  if (!container) return

  // 明後日がまだ存在しないならスクロールしない
  const items = container.querySelectorAll<HTMLElement>('.accordion-item')
  if (items.length < 3) return

  const header = document.querySelector<HTMLElement>('.overview-teble-head.week-all')
  if (!header) return

  const headerBottom = header.getBoundingClientRect().bottom
  container.scrollTop += items[2]!.getBoundingClientRect().top - headerBottom
})

const onTabClick = async (tab: 'today' | 'tomorrow' | 'future') => {
  activeTab.value = tab

  if (tab === 'future') return

  await nextTick()

  const container = weatherHourContainer.value
  if (!container) return

  const firstColumn = container.querySelector<HTMLElement>('.data-column')
  if (!firstColumn) return

  const columnWidth = firstColumn.offsetWidth

  isAutoScrolling.value = true

  if (tab === 'today') {
    container.scrollTo({
      left: 0,
      behavior: 'smooth',
    })
  }

  if (tab === 'tomorrow') {
    const tomorrowIndex = continuousHours.value.findIndex((item) => item.dayIndex === 1)

    if (tomorrowIndex !== -1) {
      container.scrollTo({
        left: tomorrowIndex * columnWidth,
        behavior: 'smooth',
      })
    }
  }

  setTimeout(() => {
    isAutoScrolling.value = false
  }, 500)
}

// 航路情報の取得
const flightRoutes = ref<FlightRoute[]>([])
const selectedFlightRouteId = ref<number | null>(null)
const isLoadingRoutes = ref(false)
const selectedRoute = computed(() =>
  flightRoutes.value.find((r) => r.flight_route_id === selectedFlightRouteId.value),
)

// 時刻関係
const minDate = computed(() => formatLocalDate(baseNow.value))

const maxDate = computed(() => {
  const d = new Date(baseNow.value)
  d.setDate(d.getDate() + 14)
  return formatLocalDate(d)
})

const routeWeatherCache = new Map<
  string,
  {
    route: RouteWeatherPoint[]
    upper: UpperWeatherPoint[]
  }
>()

const routeStartTimeText = computed(() => {
  const first = selectedRoute.value?.points?.[0]
  if (!first) return '--:--'

  const time = calculatePointTime(departureDateTime.value, first.point_pass_time)
  return time.toTimeString().slice(0, 5)
})

const routeEndTimeText = computed(() => {
  const last = selectedRoute.value?.points?.[(selectedRoute.value?.points?.length ?? 1) - 1]

  if (!last) return '--:--'

  const time = calculatePointTime(departureDateTime.value, last.point_pass_time)
  return time.toTimeString().slice(0, 5)
})

// 入力用
const inputDate = ref(formatLocalDate(baseNow.value))
const inputHour = ref(baseNow.value.getHours())
const inputMinute = ref(baseNow.value.getMinutes())

// 検索確定用
const searchDate = ref(formatLocalDate(baseNow.value))
const searchHour = ref(baseNow.value.getHours())
const searchMinute = ref(baseNow.value.getMinutes())

const onSearch = async () => {
  if (!selectedFlightRouteId.value || !flightAreaStore.selectedFlightAreaId) return

  searchDate.value = inputDate.value
  searchHour.value = inputHour.value
  searchMinute.value = inputMinute.value

  const areaId = flightAreaStore.selectedFlightAreaId
  const routeId = selectedFlightRouteId.value

  const key = `${areaId}_${routeId}_${searchDate.value}`

  // キャッシュ利用
  if (routeWeatherCache.has(key)) {
    const cached = routeWeatherCache.get(key)!
    routeWeathers.value = cached.route
    upperWeathers.value = cached.upper
    return
  }

  isSearching.value = true

  try {
    const start = new Date(
      `${searchDate.value} ${String(searchHour.value).padStart(2, '0')}:${String(searchMinute.value).padStart(2, '0')}`,
    )

    const route = await fetchRouteWeather(areaId, routeId, start)
    const upper = await fetchUpperWind(areaId, routeId, start)

    routeWeathers.value = route
    upperWeathers.value = upper

    // キャッシュ保存
    routeWeatherCache.set(key, {
      route,
      upper,
    })
  } finally {
    isSearching.value = false
  }
}

function formatLocalDate(d: Date) {
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

const routeRiskLevel = computed(() => {
  if (!flatRouteWeathers.value.length) return 0

  const alerts = flatRouteWeathers.value.map((p) => p.alert)

  if (alerts.includes(2)) return 2
  if (alerts.includes(1)) return 1

  return 0
})

// 航路上の風況取得
const routeWeathers = ref<RouteWeatherPoint[]>([])
const isSearching = ref(false)
const departureDateTime = computed(() => {
  return new Date(
    `${searchDate.value} ${String(searchHour.value).padStart(2, '0')}:${String(searchMinute.value).padStart(2, '0')}`,
  )
})

const flatRouteWeathers = computed<FlatRouteWeather[]>(() => {
  if (!routeWeathers.value.length) return []

  return routeWeathers.value
    .map((point): FlatRouteWeather | null => {
      const passTime = calculatePointTime(departureDateTime.value, point.point_pass_time)

      const nearestWind = findWindByRoundedTime(point.winds, passTime)
      if (!nearestWind) return null

      return {
        pointName: point.point_name,
        height: point.point_height,
        time: passTime.toTimeString().slice(0, 5),
        windSpeed: nearestWind.wind_speed,
        windDir: nearestWind.wind_dir,
        alert: nearestWind.wind_alert,
        pointProfileFlg: point.point_profile_flg,
        pointPortCd: point.point_port_cd,
      }
    })
    .filter((p): p is FlatRouteWeather => p !== null)
})

const parsePassTimeToMinutes = (passTime: string) => {
  const [h, m] = passTime.split(':').map(Number)
  if (h === undefined || m === undefined) return 0
  return h * 60 + m
}

const calculatePointTime = (startTime: Date, passTime: string) => {
  const minutes = parsePassTimeToMinutes(passTime)
  const newTime = new Date(startTime)
  newTime.setMinutes(startTime.getMinutes() + minutes)
  return newTime
}

const findWindByRoundedTime = (winds: RouteWind[], targetTime: Date) => {
  if (!winds.length) return null
  const roundedTime = ceilTo30Minutes(targetTime).getTime()
  return winds.find((w) => new Date(w.forecast_time).getTime() === roundedTime) ?? null
}

// 上空の風況取得
const upperWeathers = ref<UpperWeatherPoint[]>([])

// 30分切り捨て
const floorTo30Minutes = (date: Date) => {
  const d = new Date(date)
  const minutes = d.getMinutes()
  d.setMinutes(minutes < 30 ? 0 : 30, 0, 0)
  return d
}

const ceilTo30Minutes = (date: Date) => {
  const d = new Date(date)
  const m = d.getMinutes()

  if (m === 0 || m === 30) return d

  if (m < 30) {
    d.setMinutes(30, 0, 0)
  } else {
    d.setHours(d.getHours() + 1)
    d.setMinutes(0, 0, 0)
  }

  return d
}
const DISPLAY_BEFORE_HOUR = 2
const DISPLAY_AFTER_HOUR = 6

const displayStart = computed(() => {
  const base = floorTo30Minutes(departureDateTime.value)
  const d = new Date(base)
  d.setHours(d.getHours() - DISPLAY_BEFORE_HOUR)
  return d
})

const displayEnd = computed(() => {
  const base = floorTo30Minutes(departureDateTime.value)
  const d = new Date(base)
  d.setHours(d.getHours() + DISPLAY_AFTER_HOUR)
  return d
})

const filteredUpperWeathers = computed<UpperWeatherPoint[]>(() => {
  return upperWeathers.value.map((point) => {
    const filteredWinds = point.winds.filter((w) => {
      const t = new Date(w.forecast_time).getTime()
      return t >= displayStart.value.getTime() && t <= displayEnd.value.getTime()
    })

    return {
      ...point,
      winds: filteredWinds,
    }
  })
})
// 青色判定
const highlightTime = computed(() => ceilTo30Minutes(departureDateTime.value).getTime())

// 航路情報がないときの処理
const hasRoutes = computed(() => flightRoutes.value.length > 0)
const hasRouteWind = computed(() => routeWeathers.value.length > 0)
const hasUpperWind = computed(() => upperWeathers.value.length > 0)

// 5秒に一回更新する処理
const checkAndRefresh = async () => {
  try {
    const latestTimeInfo = await fetchTimeInfo()

    // まだ何もない場合は初期セット
    if (!timeInfo.value) {
      timeInfo.value = latestTimeInfo
      return
    }

    // 更新時刻が変わっていたら再取得
    if (latestTimeInfo.upd_time !== timeInfo.value.upd_time) {
      console.log('気象データ更新検知')

      timeInfo.value = latestTimeInfo

      // キャッシュクリア
      routeWeatherCache.clear()

      // エリア天気を再取得
      if (flightAreaStore.selectedFlightAreaId != null) {
        weathers.value = await fetchAreaWeather(flightAreaStore.selectedFlightAreaId, baseNow.value)
      }

      // 航路検索済みなら再取得
      if (selectedFlightRouteId.value) {
        await onSearch()
      }
    }
  } catch (e) {
    console.error('更新チェック失敗', e)
  }
}
let refreshTimer: number | undefined
onMounted(() => {
  refreshTimer = window.setInterval(() => {
    checkAndRefresh()
  }, REFRESH_INTERVAL_MS)
})
onUnmounted(() => {
  if (refreshTimer) {
    clearInterval(refreshTimer)
  }
})

watch(
  () => flightAreaStore.selectedFlightAreaId,
  async (areaId) => {
    if (!areaId) {
      flightRoutes.value = []
      selectedFlightRouteId.value = null
      return
    }

    const areas = await fetchFlightAreas()
    const exists = areas.some((a) => a.flight_area_id === areaId)
    if (!exists) {
      window.location.reload()
      return
    }

    isLoadingRoutes.value = true
    try {
      weathers.value = await fetchAreaWeather(areaId, baseNow.value)
      flightRoutes.value = await fetchFlightRoutes(areaId)
      selectedFlightRouteId.value = flightRoutes.value[0]?.flight_route_id ?? null

      // エリア変更時に自動検索
      if (selectedFlightRouteId.value) {
        await onSearch()
      }
    } finally {
      isLoadingRoutes.value = false
    }
  },
  { immediate: true },
)

onMounted(async () => {
  timeInfo.value = await fetchTimeInfo()
  // 出発日時に値をセット
  const initial = baseNow.value
  inputDate.value = formatLocalDate(initial)
  inputHour.value = initial.getHours()
  inputMinute.value = initial.getMinutes()
  searchDate.value = inputDate.value
  searchHour.value = inputHour.value
  searchMinute.value = inputMinute.value

  if (flightAreaStore.selectedFlightAreaId != null) {
    weathers.value = await fetchAreaWeather(flightAreaStore.selectedFlightAreaId, baseNow.value)
  }
  // 初回だけ自動検索
  if (selectedFlightRouteId.value) {
    await onSearch()
  }
})
</script>
